import React from "react";
import { m } from "kremling";

export function TextCell({ value, isDisabled }) {
  return (
    <span className={m("cp-table-cell-disabled", isDisabled)}>{value}</span>
  );
}
